import BookingList from './BookingList'
import BookingSingle from './BookingSingle'
import BookingSingleOverview from './BookingSingleOverview'
import BookingSingleSearch from './BookingSingleSearch'
import BookingSinglePayment from './BookingSinglePayment'
import BookingSingleInvoice from './BookingSingleInvoice'
import BookingEdit from './BookingEdit'
import BookingDuplicate from './BookingDuplicate'

export default {
  BookingList,
  BookingSingle,
  BookingSingleOverview,
  BookingSingleSearch,
  BookingSinglePayment,
  BookingSingleInvoice,
  BookingEdit,
  BookingDuplicate
}
